import { render, staticRenderFns } from "./RecievedInventories.vue?vue&type=template&id=206b3f0e"
import script from "./RecievedInventories.vue?vue&type=script&lang=js"
export * from "./RecievedInventories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports